// Whether the site plays trailers on the visitor's screen size. Sites allow
// trailers per screen size; tablet widths (641-1024px) are neither mobile nor
// desktop, so they get none. Screen size is only known on the client, so read
// this inside <ClientOnly>.
export const useTourTrailers = () => {
  const currentSite = inject("currentSite")
  const { isMobile, isDesktop } = useResponsive()

  const trailersAllowed = computed(
    () =>
      (isMobile.value && !!currentSite.value.showTrailersOnMobile) ||
      (isDesktop.value && !!currentSite.value.showTrailersOnDesktop),
  )

  return { trailersAllowed }
}
